import { PLAYER_PORTALS_MODELS } from '@r-and-a-shared-ui/common-kontent-client';

export const regex_validation = (data: PLAYER_PORTALS_MODELS.RegexValidation) => {
  if (!data || !data?.elements) {
    return undefined;
  }

  const { elements } = data;

  return {
    regex: elements?.regex?.value,
    validationMessage: elements?.validation_message?.value,
  };
};

export default regex_validation;
